// MA-107: the router's defaultOnCatch. Route crashes are swallowed by TanStack's
// per-route CatchBoundary and never reach the root ErrorBoundary, so this is the
// one place they reach Sentry. `capture` is injected so a test can prove the call.
export function makeRouteOnCatch(
  capture: (error: unknown, componentStack?: string) => void,
): ((error: unknown, info?: { componentStack?: string | null } | null) => void) & { __capture: typeof capture } {
  const onCatch = (error: unknown, info?: { componentStack?: string | null } | null) => {
    try { capture(error, String(info?.componentStack || "")); }
    catch { /* never let reporting crash the boundary */ }
  };
  // Exposed so a test can prove the router is wired to the REAL Sentry capture.
  return Object.assign(onCatch, { __capture: capture });
}
